import React from 'react';
import { Link } from 'react-router-dom';

const SoftwareCard = ({ software }) => {
  return (
    <div className="software-card">
      <div className="software-icon">{software.icon}</div>
      <h3 className="software-name">{software.name}</h3>
      <span className="software-category">{software.category}</span>
      <p className="software-description">{software.description.substring(0, 60)}...</p>
      <Link to={`/software/${software.id}`} className="view-details-btn">
        查看详情
      </Link>
    </div>
  );
};

export default SoftwareCard;